<div class="top">
	<h2>{{ template.name }}</h2>

	<button mat-icon-button class="copy-btn"
	        aria-label="Copy to Clipboard"
	        (click)="onCopy()" color="primary">
		<mat-icon>content_copy</mat-icon>
	</button>
</div>

<div #content [innerHtml]="template.content"></div>
